let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3L085")).then(() => parcelRequire('966Nd'));